import React from "react"
import PropTypes from "prop-types"
import ReactHtmlParser from "react-html-parser"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./tooltip.scss"

library.add(faInfoCircle)

const Tooltip = ({ text }) => (
  <div className="tooltip">
    <FontAwesomeIcon icon="info-circle" />
    <span className="tooltiptext">{ReactHtmlParser(text)}</span>
  </div>
)

Tooltip.propTypes = {
  text: PropTypes.string.isRequired
}

export default Tooltip
